/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiAnalyticEventVignetteHotspotClickedFromJSON(json) {
    return StreemApiAnalyticEventVignetteHotspotClickedFromJSONTyped(json, false);
}
export function StreemApiAnalyticEventVignetteHotspotClickedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'hotspotId': !exists(json, 'hotspot_id') ? undefined : json['hotspot_id'],
        'hotspotType': !exists(json, 'hotspot_type') ? undefined : json['hotspot_type'],
    };
}
export function StreemApiAnalyticEventVignetteHotspotClickedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'hotspot_id': value.hotspotId,
        'hotspot_type': value.hotspotType,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiAnalyticEventVignetteHotspotClickedHotspotType;
(function (StreemApiAnalyticEventVignetteHotspotClickedHotspotType) {
    StreemApiAnalyticEventVignetteHotspotClickedHotspotType["MODAL"] = "HOTSPOT_TYPE_MODAL";
    StreemApiAnalyticEventVignetteHotspotClickedHotspotType["PORTAL"] = "HOTSPOT_TYPE_PORTAL";
    StreemApiAnalyticEventVignetteHotspotClickedHotspotType["INVALID"] = "HOTSPOT_TYPE_INVALID";
})(StreemApiAnalyticEventVignetteHotspotClickedHotspotType || (StreemApiAnalyticEventVignetteHotspotClickedHotspotType = {}));
//# sourceMappingURL=StreemApiAnalyticEventVignetteHotspotClicked.js.map